import { useTeam } from 'app/frontend/base/config/context/team'
import { useOverviewData, usePageInfo } from 'app/frontend/base/config/queries'
import TileWrapper from '../TileWrapper'
import { difficultiesLabels } from 'app/frontend/types/custom/Difficulty'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import EventAvatar from 'app/frontend/base/components/EventAvatar'

const RaidProgressTile = () => {
  const { team } = useTeam()
  const { data: overviewData } = useOverviewData(team.id)
  const {
    data: { currentSeason },
  } = usePageInfo()

  if (!overviewData?.raidProgress)
    return (
      <TileWrapper>
        <p className='text-muted-foreground'>No raid progress found</p>
      </TileWrapper>
    )

  return (
    <TileWrapper>
      <div className='text-lg flex items-center gap-2 justify-center'>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className='inline-flex'>
              <EventAvatar
                instances={overviewData.raidProgress.instances}
                className='w-8 h-8 border mr-1'
              />
            </span>
          </TooltipTrigger>
          <TooltipContent>
            {currentSeason.expansion} {currentSeason.name}
          </TooltipContent>
        </Tooltip>
        <span>
          <span>{overviewData.raidProgress.kills}</span> /{' '}
          {overviewData.raidProgress.total}
        </span>
        {difficultiesLabels[overviewData.raidProgress.difficulty]}
      </div>
    </TileWrapper>
  )
}

export default RaidProgressTile
